import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cuándo recibo el acceso?',
  a: '¡Inmediatamente! Una vez confirmado el pago, recibirás un correo con el enlace para acceder a toda la biblioteca y bonos al instante.'
}, {
  q: '¿Es digital o físico?',
  a: 'Es 100% digital. Tendrás acceso a carpetas organizadas en la nube para ver o descargar los PDFs en tu celular, tablet o PC.'
}, {
  q: '¿Sirve para principiantes?',
  a: "¡Sí! Incluimos la 'Guía Esencial para Empezar a Tejer' como bono gratuito, ideal para dar tus primeros pasos."
}, {
  q: '¿Puedo usar los patrones para vender?',
  a: 'Absolutamente. Puedes tejer todas las piezas que quieras y vender los productos terminados.'
}, {
  q: '¿El acceso vence?',
  a: 'No, el acceso es de por vida. Pagas una sola vez y tienes acceso para siempre, incluyendo futuras actualizaciones.'
}, {
  q: '¿Y si no me gusta?',
  a: 'Tienes nuestra garantía de 7 días. Si no es lo que esperabas, te devolvemos el 100% de tu dinero sin preguntas.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-12 px-6 bg-white" data-id="element-102">
      <div className="max-w-3xl mx-auto" data-id="element-103">
        <h2 className="text-2xl md:text-3xl font-bold text-dark mb-8 text-center" data-id="element-104">
          PREGUNTAS{' '}
          <span className="italic text-rose-deep font-normal" data-id="element-105">FRECUENTES</span>
        </h2>

        <div className="space-y-3" data-id="element-106">
          {faqs.map((faq, index) => <div key={index} className="border border-cream rounded-xl overflow-hidden bg-cream/10" data-id="element-107">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-5 py-4 text-left flex justify-between items-center hover:bg-cream/30 transition-colors" data-id="element-108">
                <span className="font-semibold text-dark text-sm md:text-base pr-4" data-id="element-109">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-rose-deep transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-110" />
              </button>
              <AnimatePresence data-id="element-111">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} data-id="element-112">
                    <div className="px-5 pb-4 text-dark/70 text-sm md:text-base leading-relaxed" data-id="element-113">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}